import { Tag, TAG_HEIGHT } from '../../Tag'
import { isEmailHighPriority } from '../Email.utils'
import { EmailPriorityTag } from '../EmailPriorityTag'

import { EmailAttachedTagDate } from './EmailAttachedTagDate'
import { EmailAttachedTagParticipants } from './EmailAttachedTagParticipants'

import * as styles from './EmailAttachedTag.module.css'

function EmailAttachedTag({
  className = styles.EmailAttachedTag,
  disabled,
  height = TAG_HEIGHT.height40,
  item,
  withTooltip = true,
  onDelete,
  ...restProps
}) {
  function handleRemove() {
    onDelete(item.uuid)
  }

  const lastMessage = item.last_message
  const date = lastMessage.created

  return (
    <Tag
      {...restProps}
      afterContent={isEmailHighPriority(item) ? <EmailPriorityTag /> : null}
      beforeContent={<EmailAttachedTagParticipants lastMessage={lastMessage} />}
      className={className}
      height={height}
      isDisabled={disabled}
      meta={date ? <EmailAttachedTagDate date={date} /> : null}
      secondText={lastMessage.text}
      text={item.title}
      withTooltip={withTooltip}
      onRemove={onDelete && !disabled ? handleRemove : undefined}
    />
  )
}

export default EmailAttachedTag
